import { styled } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

export const SELECTION_COLUMN_WIDTH = 58;

export const StyledTableCardWrapper = styled(Stack)`
    margin-bottom: 40px;
    width: 100%;
    min-width: 0;

    [data-automation="table-top-header"] {
        position: sticky;
        top: 0;
        z-index: 10;
        background-color: ${colorsPalettes.carbon["0"]};
    }
    col.ant-table-selection-col,
    .ant-table-selection-col,
    th.ant-table-selection-column,
    td.ant-table-selection-column {
        width: ${SELECTION_COLUMN_WIDTH}px !important;
        min-width: ${SELECTION_COLUMN_WIDTH}px !important;
        max-width: ${SELECTION_COLUMN_WIDTH}px !important;
    }

    [data-automation="table-top-selection-checkbox"] {
        padding-left: 0;

        .ant-checkbox-wrapper {
            margin-left: -12px;
            margin-right: 12px;
            width: ${SELECTION_COLUMN_WIDTH}px;
            height: 56px;
            justify-content: center;
        }
    }
`;
